var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsecaseImg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.3 469.1 47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87a56 56 0 0 0 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3l42.4-84.9 1.7 3.4a56 56 0 0 0 50.1 31h104.5c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1a40.6 40.6 0 0 1-55.4 0zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3a24 24 0 0 0-43 0l-41.4 82.8-51-113.9a23.9 23.9 0 0 0-44 .7l-31.8 76.3a8 8 0 0 1-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1-5.7-16-8.7-33-8.7-50.3v-5.8A143 143 0 0 1 244 84l12 12 12-12a143 143 0 0 1 244 101.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsecaseImg3);
export default __webpack_public_path__ + "static/media/usecaseImg3.e20690baf8858f18b96ef3f141d9a608.svg";
export { ForwardRef as ReactComponent };